import { GatsbyProps } from 'models/gatsby-props';

// The order of imports is important!
import { app, appReset, appWhiteSpace } from './app.module.scss';
import { Footer } from './footer';
import { Navbar } from './navbar';

interface Props extends GatsbyProps {
    isLandingPage?: boolean;
}

export const App = ({ location, children, isLandingPage = false }: Props) => {
    return (
        <main className={`${isLandingPage ? appReset : ''} ${app}  ${isLandingPage ? appWhiteSpace : ''}`}>
            <>
                {process.env.GATSBY_SITE_URL === 'https://elumity.com' ? (
                    <noscript>
                        {`
                <!-- Google Tag Manager (noscript) -->
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KFLMDN5Z"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>
                <!-- End Google Tag Manager (noscript) -->
            `}
                    </noscript>
                ) : (
                    ''
                )}

                <Navbar isLandingPage={isLandingPage} location={location} />
                {children}
                <Footer />
            </>
        </main>
    );
};
